import React, { FC, useEffect } from 'react'
import { observer } from 'mobx-react'
import { payMobx } from '@mobxStore'
import { IonHeader, IonModal } from '@ionic/react'
import CardConnectTokenizer from '../Tokenizer/CardConnect'
import HeartlandTokenizer from '../Tokenizer/Heartland'
import './index.scss'

interface IProps {
  payRechargeFlag?: boolean;
  multiUse?: boolean;
  resolve?: (card: any) => void;
  reject?: () => void;
}

const BankCardAuthModal: FC<IProps> = ({ payRechargeFlag, multiUse, resolve, reject }) => {
  const onBackCardAuthorized = (card: any) => {
    resolve(card)
  }

  return (
    <IonModal
      isOpen
      cssClass='bank-card-auth-modal'
      onDidDismiss={reject}
    >
      <IonHeader>
        <div className='bank-card-auth-header'>
          <span>{multiUse ? i18n.t('pay.addBankCard') : i18n.t('pay.inputBankCardInfo')}</span>
          <i className='iconfont icon-close' data-cypid='bankCardAuthModalClose' onClick={reject} />
        </div>
      </IonHeader>
      {payMobx.methodChannelMap.bankCardOnline === 'CardConnectBankCard' && (
        <CardConnectTokenizer payRechargeFlag={payRechargeFlag} onAuthorize={onBackCardAuthorized} />
      )}
      {payMobx.methodChannelMap.bankCardOnline === 'HeartLandBankCard' && (
        <HeartlandTokenizer payRechargeFlag={payRechargeFlag} multiUse={multiUse} onAuthorize={onBackCardAuthorized} />
      )}
    </IonModal>
  )
}

export default observer(BankCardAuthModal)
